import { MessageService } from '@philips-emr/tws-core/lib/services';
import { registerValidator, Validation } from '@philips-emr/tws-core/lib/services/model-service';

const PW_VALIDATOR = 'passwordValidator';
const PW = /^(?=.*?[A-Z])(?=(.*[a-z]))(?=(.*[\d]))(?=(.*[\W_])).{8,16}$/;

const PW_EQUALS = 'password-equals';

enum Validator {
  LENGTH = 'password-length',
  CONTAINS_LOWERCASE = 'password-contains-lowercase',
  CONTAINS_UPPERCASE = 'password-contains-uppercase',
  CONTAINS_NUMBER = 'password-contains-number',
  CONTAINS_SIMBOL = 'password-contains-simbol',
}

const validators: { [key in Validator]: { message: string, validation: (value: string) => boolean } } = {
  [Validator.LENGTH]: {
    message: 'pa.password-length',
    validation: (value: string): boolean => value.length >= 8 && value.length <= 16,
  },
  [Validator.CONTAINS_LOWERCASE]: {
    message: 'pa.password-contains-lowercase',
    validation: (value: string): boolean => isValid(value, /[a-z]/g),
  },
  [Validator.CONTAINS_UPPERCASE]: {
    message: 'pa.password-contains-uppercase',
    validation: (value: string): boolean => isValid(value, /[A-Z]/g),
  },
  [Validator.CONTAINS_NUMBER]: {
    message: 'pa.password-contains-number',
    validation: (value: string): boolean => isValid(value, /[\d]/g),
  },
  [Validator.CONTAINS_SIMBOL]: {
    message: 'pa.password-contains-simbol',
    validation: (value: string): boolean => isValid(value, /[\W_]/g),
  },
};

function passwordValidator(): void {
  Object.entries(validators).forEach(([key, props]) =>
    registerValidator(key, (value: string): Validation[] =>
      [{
        message: MessageService.translate(props.message),
        name: key,
        valid: !!value && props.validation(value),
      }]
    )
  );
}

function isValid(value: string, matcher: RegExp): boolean {
  const result = RegExp(matcher).exec(value);

  if (Array.isArray(result)) {
    return result.length >= 1;
  }
  return false;
}

export default registerValidator('password-validator', (value: string) => {
  if (!value) {
    return [];
  }

  const valid = Boolean(RegExp(PW).exec(value));

  return [
    {
      message: !valid ? 'pa.invalid-password' : '',
      name: PW_VALIDATOR,
      valid,
    },
  ];
});

function passwordEqualsValidator(value: string, equals: string): Validation[] {
  const valid = equals !== value;

  return [{
    message: !valid ? 'pa.password-new-equal-current' : '',
    name: PW_EQUALS,
    valid,
  }];
}

export {
  PW_EQUALS,
  passwordEqualsValidator,
  passwordValidator,
};
